(function () {
  const breakpoint = window.matchMedia( '(min-width: 991px)' );
  let mySwiper;
  const breakpointChecker = function() {

    // if larger viewport and multi-row layout needed
    if ( breakpoint.matches === true ) {

      // clean up old instances and inline styles when available
	  if ( mySwiper !== undefined ) mySwiper.destroy( true, true );

	  // or/and do nothing
	  return;

      // else if a small viewport and single column layout needed
      } else if ( breakpoint.matches === false ) {

        // fire small viewport version of swiper
        return enableSwiper();

      }

  };
  const enableSwiper = function() {
    mySwiper = new Swiper('.js-text-column__swiper', {
      slidesPerView: 1,
      spaceBetween: 20,
      centeredSlides: true,
      pagination: {
        el: '.js-text-column__block-pagination',
        type: 'bullets',
        clickable: true
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 10
        },
        468: {
          slidesPerView: 2,
          spaceBetween: 20
        },
        767: {
          slidesPerView: 3,
          spaceBetween: 25
        }
      }
    });
  }

  // keep an eye on viewport size changes
  breakpoint.addEventListener('change', () => {
    breakpointChecker();
  })

  // kickstart
  breakpointChecker();
})();
